<svg id="d" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  [attr.viewBox]="showText() ? '0 0 418.72 97.73' : '0 0 140 97.73'">
  <defs>
    <style>.k {
      fill: url(#j);
    }

    .l {
      fill: url(#i);
    }

    .m {
      fill: url(#h);
    }

    .n {
      fill: url(#g);
    }

    .o {
      fill: url(#f);
    }

    .p {
      fill: url(#e);
    }</style>
    <linearGradient id="e" x1="48.01" y1="77.82" x2="48.01" y2="24.69" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#8261f0"/>
      <stop offset=".98" stop-color="#fd615a"/>
    </linearGradient>
    <linearGradient id="f" x1="26.65" y1="90.03" x2="26.65" y2="31.82" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#5afd95"/>
      <stop offset=".03" stop-color="#58f791"/>
      <stop offset=".35" stop-color="#45c373"/>
      <stop offset=".63" stop-color="#389d5d"/>
      <stop offset=".86" stop-color="#30864f"/>
      <stop offset="1" stop-color="#2d7e4b"/>
    </linearGradient>
    <linearGradient id="g" x1="93.24" y1="108.08" x2="93.24" y2="8.54" gradientUnits="userSpaceOnUse">
      <stop offset=".03" stop-color="#5afd95"/>
      <stop offset=".17" stop-color="#57f791"/>
      <stop offset=".35" stop-color="#52e788"/>
      <stop offset=".55" stop-color="#48cc78"/>
      <stop offset=".77" stop-color="#3ba762"/>
      <stop offset=".97" stop-color="#2d7e4b"/>
    </linearGradient>
    <linearGradient id="h" x1="9.86" y1="76.55" x2="9.86" y2="44" xlink:href="#e"/>
    <linearGradient id="i" x1="93.24" y1="97.73" x2="93.24" y2="5.77" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#2d7e4b" stop-opacity=".3"/>
      <stop offset=".02" stop-color="#2d7e4b" stop-opacity=".5"/>
      <stop offset=".05" stop-color="#318b53" stop-opacity=".45"/>
      <stop offset=".09" stop-color="#3fb269" stop-opacity=".29"/>
      <stop offset=".14" stop-color="#55f18e" stop-opacity=".05"/>
      <stop offset=".15" stop-color="#5afd95" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="j" x1="26.65" y1="89.49" x2="26.65" y2="30.88" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#2d7e4b" stop-opacity=".3"/>
      <stop offset=".02" stop-color="#2d7e4b" stop-opacity=".5"/>
      <stop offset=".05" stop-color="#318b53" stop-opacity=".45"/>
      <stop offset=".09" stop-color="#3fb269" stop-opacity=".29"/>
      <stop offset=".14" stop-color="#55f18e" stop-opacity=".05"/>
      <stop offset=".15" stop-color="#5afd95" stop-opacity="0"/>
    </linearGradient>
  </defs>
  @if (showText()) {
    <path class="logo-text"
          d="M146.3,40.33h7.43c.39,0,.67.18.74.6l6.41,27.65,2.62,11.33,2.48-11.33,6.09-27.65c.11-.43.39-.6.78-.6h8.78c.39,0,.64.18.74.6l6.23,27.68,2.66,11.86,2.69-12,6.27-27.54c.07-.43.36-.6.74-.6h6.83c.46,0,.71.28.6.74l-12.07,48.22c-.11.42-.35.6-.71.6h-9.17c-.39,0-.64-.18-.74-.6l-6.58-27.51-2.27-9.59-2.19,9.66-6.19,27.43c-.11.42-.36.6-.74.6h-9.42c-.39,0-.64-.18-.74-.6l-11.82-48.22c-.11-.46.11-.74.57-.74Z"/>
    <path class="logo-text"
          d="M212.67,89.21l.21-17.84-.21-17.28c0-.46.25-.67.67-.67h7.4c.42,0,.64.21.64.67l-.21,17.28.21,17.84c0,.46-.21.67-.64.67h-7.4c-.42,0-.67-.21-.67-.67ZM212.75,45.44h0c0-2.26,1.83-4.09,4.09-4.09h.46c2.26,0,4.09,1.83,4.09,4.09h0c0,2.26-1.83,4.09-4.09,4.09h-.46c-2.26,0-4.09-1.83-4.09-4.09Z"/>
    <path class="logo-text"
          d="M227.11,78.35c0-.42.21-.67.67-.67h6.9c.42,0,.67.25.67.67.28,4.82,3.36,6.97,9.1,6.97,4.78,0,7.72-1.98,7.72-5.49,0-8.42-24.25-1.17-24.25-16.11,0-7.26,5.91-11.12,15.15-11.12s15.33,3.54,15.93,10.94c.03.46-.25.71-.67.71h-6.62c-.42,0-.64-.21-.71-.64-.46-3.79-3.26-5.74-8.04-5.74-4.21,0-6.9,1.63-6.9,5.24,0,8.14,24.21.6,24.21,16,0,7.36-6.9,11.58-16.11,11.58-10.02,0-16.71-4.18-17.06-12.36Z"/>
    <path class="logo-text"
          d="M264.58,71.73c0-10.51,5.8-19.05,15.58-19.05,4.82,0,8.53,1.95,10.94,5.52l-.11-17.2c0-.42.25-.67.67-.67h7.29c.42,0,.67.21.67.67l-.18,22.62.18,25.59c0,.46-.25.67-.67.67h-7.26c-.42,0-.67-.21-.64-.67l.14-4.57c-2.44,3.72-6.23,5.95-11.19,5.95-10.09,0-15.44-8.25-15.44-18.87ZM291.41,72.01c.07-8.67-3.15-13.56-8.92-13.63-6.23-.11-9.24,4.92-9.24,12.92,0,8.5,3.05,13.63,9.06,13.59,5.66,0,9.03-4.32,9.1-12.89Z"/>
    <path class="logo-text" d="M304.73,71.73c0-11.51,6.55-19.15,18.02-19.15s17.95,7.47,17.95,19.01-6.44,19.15-17.95,19.15-18.02-7.47-18.02-19.01ZM331.96,71.73c0-8.71-3.04-13.42-9.24-13.42-6.3.07-9.27,4.74-9.27,13.49s3.08,13.21,9.31,13.21,9.2-4.43,9.2-13.28Z"/>
    <path class="logo-text"
          d="M345.57,89.21l.25-16.35-.14-18.76c0-.42.25-.67.67-.67h6.9c.42,0,.67.21.67.67l-.18,4.82c2.34-3.47,6.48-6.34,11.93-6.34,7.61,0,12.46,5.06,12.46,14.34v7.43l.18,14.87c0,.46-.25.67-.67.67h-7.29c-.42,0-.67-.21-.67-.67l.18-14.87v-7.22c0-5.45-2.8-8.21-6.66-8.21-4.32,0-8.32,3.68-9.03,11.15v4.28l.14,14.87c0,.46-.25.67-.67.67h-7.4c-.43,0-.67-.21-.67-.67Z"/>
    <path class="logo-text"
          d="M383.03,71.76c0-11.47,6.65-19.19,17.81-19.19s17.63,7.51,17.88,19.86c0,.46-.25.67-.67.67h-26.45c.28,8.25,3.68,11.9,9.63,11.9,4.46,0,7.33-2.16,8.36-6.34.14-.39.35-.57.74-.57h6.87c.43,0,.71.18.67.49-.99,6.69-6.94,12.14-16.75,12.14-11.79,0-18.09-7.86-18.09-18.97ZM409.51,67.58c-.32-4.96-3.05-9.31-8.64-9.31-5.17,0-8.18,3.33-9.03,9.31h17.67Z"/>
  }
  <path class="p" d="M64.97,19.97c.31,0,.54.29.47.6l-17.14,69.09c-.19,1.1-1.92,1.05-2.07-.05l-12.63-62.45s-1.03-5.55-2.94-6.88c-.13-.09-.06-.28.09-.28l34.22-.02Z"/>
  <path class="o" d="M40.62,89.67H12.36c-.17,0-.23-.26-.06-.3,1.45-.36,2.49-5.32,2.49-5.32l11.82-56.04c.16-1.16,1.96-1.16,2.13.02l12.35,61.07c.06.3-.17.58-.47.58Z"/>
  <path class="n" d="M136.25,0c.15,0,.23.18.11.28-5.81,4.51-28.29,63.13-36.39,83.32-3.19,7.95-9.66,14.13-18.1,14.13,0,0-26.39-.02-31.65-.02-.16,0-.22-.19-.09-.28,1.92-1.33,3.24-6.98,3.24-6.98L72.54,14.13c2.08-8.31,9.54-14.13,18.1-14.13h45.61Z"/>
  <path class="m" d="M19.24,40.74c.31,0,.53.28.47.58l-9.48,41.94c-.2,1.09-1.93,1.06-2.07-.05,0,0-5.15-38.65-8.12-42.21-.1-.11-.01-.26.14-.26h19.06Z"/>
  <path class="l" d="M136.25,0c.15,0,.23.18.11.28-5.81,4.51-28.29,63.13-36.39,83.32-3.19,7.95-9.66,14.13-18.1,14.13,0,0-26.39-.02-31.65-.02-.16,0-.22-.19-.09-.28,1.92-1.33,3.24-6.98,3.24-6.98L72.54,14.13c2.08-8.31,9.54-14.13,18.1-14.13h45.61Z"/>
  <path class="k" d="M40.62,89.67H12.36c-.17,0-.23-.26-.06-.3,1.45-.36,2.49-5.32,2.49-5.32l11.82-56.04c.16-1.16,1.96-1.16,2.13.02l12.35,61.07c.06.3-.17.58-.47.58Z"/>
</svg>
